import styled from "styled-components";
import Content from "../components/content";
import { Box } from "@mui/material";

const Holder = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    overflow: auto;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 48px;
    padding-bottom: 24px;
`;

const SubTitle = styled.p`
    color: #181122;
    text-align: center;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
`;

export default function Maintenance({ title, isNotice }) {

    return (
        <Holder>
            <Content title={title}>
                <Box style={{ marginBottom: 40 }}>
                    <Container>
                        {isNotice ? (
                            <img src='/img/maintenanceNotice.svg' alt='imagem de alerta' title='imagem de alerta' />
                        ) : (
                            <img src='/img/maintenance.svg' alt='imagem de alerta' title='imagem de alerta' />
                        )}
                        <SubTitle>
                            {isNotice ? (
                                'Você ainda não possui nenhum aviso.'
                            ) : (
                                'Essa funcionalidade foi temporariamente desativada. Tente novamente mais tarde'
                            )}
                        </SubTitle>
                    </Container>
                </Box>
            </Content>
        </Holder>
    );
}
